export default "__VITE_ASSET__utBiUSD5__"